import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-dialog-confirm',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule],
    template: `
  <div class="modal-backdrop">
    <div class="modal-container">
      <div class="modal">
        <div class="modal-header">
          <h3 class="modal-title">Confirmar exclusão</h3>
        </div>
        <mat-dialog-content class="modal-body">
          <p>Deseja realmente excluir este documento?</p>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-footer">
          <button class="btn btn-outline btn-sm" (click)="onNoClick()">Cancelar</button>
          <button class="btn btn-sm" style="background-color: var(--color-error); color: var(--color-text-white);" (click)="onYesClick()">Excluir</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
  `
})
export class DialogConfirmComponent {
    constructor(public dialogRef: MatDialogRef<DialogConfirmComponent>) { }
    onNoClick(): void {
        this.dialogRef.close(false);
    }
    onYesClick(): void {
        this.dialogRef.close(true);
    }
}